import React from 'react';
import {
  AppBar,
  makeStyles,
  Toolbar,
  Badge,
  IconButton,
  Button,
  Typography,
  Popover
} from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MenuIcon from '@material-ui/icons/Menu';
import { useSelector } from 'react-redux';
import { appProfileSelector } from 'redux/selectors';
import { FormattedMessage } from 'react-intl';
import useRouter from 'utils/useRouter';
import TabImage from 'assets/images/tabimage.png';
import { ReactComponent as IconCart } from 'assets/svgs/product_cart.svg';
import { drawerWidth, drawerCloseWidth } from '../NavBar'
import { ROLE_APAVE_CLIENT, ROLE_ADMIN } from 'config';
import ClientSelection from './clientselect';
import { ReactComponent as IconBusiness } from 'assets/svgs/business.svg';
import SecurityIcon from '@material-ui/icons/Security';
import PropTypes from 'prop-types';

export const topbar_height = 64

const useStyles = makeStyles(theme => ({
  appBar: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    height: 64,
    minHeight: 'auto',
    boxShadow: '0 3px 3px -1px rgb(0 0 0 / 20%)',
    transition: 'all .5s ease',
    backgroundColor: 'white'
  },

  // ensure on very small screens the topbar is fixed full-width and doesn't shift
  '@media (max-width:599.95px)': {
    appBar: {
      marginLeft: 0,
      width: '100%',
      left: 0,
      transition: 'none'
    }
  },
  toolbar: {
    flex: 1,
    alignItems: 'flex-end',
    paddingLeft: '1%',
    paddingRight: '1%',
    backgroundColor: theme.palette.app.primary,
    marginBottom: 0,
    minHeight: 'unset !important'
  },
  // group left-side button + policy link so they can stack on small screens
  leftGroup: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      marginLeft: theme.spacing(0),
      marginTop: theme.spacing(1)
    }
  },
  logo: {
    height: 30,
  },
  divider: {
    width: 1,
    backgroundColor: '#868aa8',
    height: '40%',
    margin: '0 5px',
  },
  name: { whiteSpace: 'nowrap', color: '#868aa8' },
  middle: {
    whiteSpace: 'nowrap',
    color: '#868aa8',
    flex: 1,
    fontWeight: 'bold',
    textAlign: 'right'
  },
  middleLogo: {
    height: 30,
  },
  avatar: {
    width: 32,
    height: 32,
    fontSize: 14,
    backgroundColor: theme.palette.text.primary,
  },
  lng: {
    width: 32,
    height: 32,
    fontSize: 14,
    backgroundColor: theme.palette.app.primary,
  },
  langBtn: {
    color: 'white',
    border: `2px solid white`,
    borderRadius: 10,
    padding: `4px 4px`,
    marginBottom: 6,
    minWidth: 'unset',
    fontSize: 12,
    fontWeight: 'bold'
  },
  clientBtn: {
    margin: theme.spacing(0, 0, 0, 1),
    color: '#6CB570',
    backgroundColor: 'white',
    borderRadius: 10,
    borderBottomLeftRadius: '0px !important',
    borderBottomRightRadius: '0px !important',
    fontSize: 12,
    fontWeight: 'bold',
    padding: '6px 12px',
    '&:hover': {
      backgroundColor: 'white !important'
    },
    [theme.breakpoints.down('xs')]: {
      // make text slightly smaller on very small screens and prevent wrapping
      fontSize: theme.typography.pxToRem(10),
      padding: '3px 6px',
      whiteSpace: 'nowrap'
    }
  },
  clientBtnLabel: {
    display: 'block'
  },
  indicator: {
    width: 65,
    height: 5,
    backgroundColor: '#6CB570',
    borderRadius: 10,
    marginRight: 'auto',
    marginLeft: 'auto',
    marginTop: 4
  },
  tabButton: {
    color: theme.palette.app.primary,
    backgroundImage: `url(${TabImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 100%',
    padding: '5px 50px',
    backgroundColor: 'rgba(38, 50, 56, 0.04)'
  },
  InactivetabButton: {
    color: 'white',
    textTransform: 'none',
    marginBottom : 0,
    marginRight: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  iconbutton: {
    color: theme.palette.text.primary,
    fontWeight: '600',
    textTransform: 'none'
  },
  btnIcon: {
    fill: theme.palette.app.primary,
    width: 20,
    height: 20
  },
  badge: {
    backgroundColor: 'white',
    color: 'red',
    right: 23,
    fontSize: 8,
    top: 13,
    width: 16,
    height: 16,
    minWidth: 16
  },
  iconWrap: {
    width: 35,
    height: 35,
    backgroundColor: 'white',
    borderRadius: 50,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  clientSelect: {
    margin: theme.spacing(0, 1),
    width: 150,
    borderRadius: 8,
    backgroundColor: 'white',
    marginBottom: 2
  },
  policyLink: {
    color: 'white',
    fontSize: 13,
    marginBottom: 0,
    textAlign: 'center',
    '& strong': { color: 'white' },
    [theme.breakpoints.down('xs')]: {
      marginBottom: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(12)
    }
  },
  clientMenuRoot: {
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    minWidth: 180,
    backgroundColor: 'white',
    borderRadius: 8,
    boxShadow: theme.shadows[4]
  },
  clientMenuItem: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 1.5),
    textTransform: 'none',
    justifyContent: 'flex-start'
  },
  clientMenuLabel: {
    marginLeft: theme.spacing(1.5),
    color: theme.palette.text.primary,
    fontWeight: 600
  },
  rootclientSelect: {
    paddingTop: 12,
    paddingBottom: 12
  }
}));
const getAppBarStyle = (isXs, openDrawer) => {
  if (isXs) {
    return { marginLeft: 0, width: '100%' };
  }
  if (!openDrawer) {
    return { marginLeft: drawerCloseWidth, width: `calc(100% - ${drawerCloseWidth}px)` };
  }
  return {};
};

const APAVEIMAGE = require('assets/images/apave.png');

const TopBar = ({ openDrawer, setOpenDrawer, location }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('xs'));
  const [anchorClientEl, setAnchorClientEl] = React.useState(null);
  const { apaveProducts } = useSelector(state => state.cart)

  const router = useRouter();

  const { role } = useSelector(appProfileSelector);


  const [anchorEl, setAnchorEl] = React.useState(null);
  const openClient = Boolean(anchorEl);
  const popover_id = openClient ? 'simple-popover' : undefined;
  const [clientName, setClientName] = React.useState("");

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClientClick = (event) => {
    // only open client popover on xs (mobile); on desktop keep original behavior
    if (isXs) {
      setAnchorClientEl(event.currentTarget);
    }
  };

  const handleClientClose = () => {
    setAnchorClientEl(null);
  };

  return (
    <AppBar
      elevation={0}
      position="fixed"
      color="default"
      className={classes.appBar}
      style={getAppBarStyle(isXs, openDrawer)}
    >
      <Toolbar className={classes.toolbar}>
        {isXs && <IconButton edge="start" color="inherit" onClick={() => setOpenDrawer(prev => !prev)} aria-label="menu" style={{ marginLeft: 5 }}>
          <MenuIcon style={{ fill: 'white' }} />
        </IconButton>}
        <Button className={classes.tabButton}>
          <img src={APAVEIMAGE} alt="apave" className={classes.logo} />
        </Button>
        <div className={classes.leftGroup}>
          <Button className={classes.InactivetabButton}>
            Espace Client
          </Button>
          {/* hide policy link on very small screens */}
          {!isXs && (
            <a
              href="https://espaceclient.apave.com/doc/Politique de protection des données personnelles_Espace Client.pdf"
              target="_blank"
              rel="noreferrer"
              className={classes.policyLink}
            >
              <strong>{<FormattedMessage id="policy" />}</strong>
            </a>
          )}
        </div>
        {
          (role == ROLE_APAVE_CLIENT || role == ROLE_ADMIN) &&
          <>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <IconButton
              aria-describedby={"simple-popover"}
              onClick={handleClick}
              size="small"
              style={{ marginBottom: 7 }}
            >
              <IconBusiness style={{ fill: "white" }} />
            </IconButton>
            <Typography style={{ color: 'white', marginBottom: 10, marginLeft: 10 }}>{clientName}</Typography>
            <ClientSelection
              id={popover_id}
              open={openClient}
              anchorEl={anchorEl}
              handleClose={handleClose}
              setClientName={setClientName}
            />
          </>
        }
        <div className={classes.middle}>
          {
            /* hide cart button on very small screens */
            !(location.pathname?.includes("/pack-sanitaire")) && role != ROLE_APAVE_CLIENT && !isXs &&
            < Badge badgeContent={apaveProducts.length} classes={{ badge: classes.badge }}>
              <Button
                startIcon={
                  <div className={classes.iconWrap}>
                    <IconCart className={classes.btnIcon} />
                  </div>}
                className={classes.iconbutton}
                onClick={() => router.history.push('/carts')}>
              </Button>
            </Badge>
          }
        </div>
        <div>
          <Button
            classes={{
              root: classes.clientBtn,
              label: classes.clientBtnLabel
            }}
            onClick={handleClientClick}
            aria-describedby={anchorClientEl ? 'client-popover' : undefined}
          >
            {'Espace client'}
            <div className={classes.indicator} />
          </Button>
          {/* mobile popover with hidden actions (policy + cart) */}
          <Popover
            id="client-popover"
            open={Boolean(anchorClientEl)}
            anchorEl={anchorClientEl}
            onClose={handleClientClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            disableRestoreFocus
          >
            <div className={classes.clientMenuRoot}>
              <a
                href="https://espaceclient.apave.com/doc/Politique de protection des données personnelles_Espace Client.pdf"
                target="_blank"
                rel="noreferrer"
                className={classes.policyLink}
                style={{ marginBottom: 0, marginTop: 2 }}
              >
                <Button className={classes.clientMenuItem} onClick={handleClientClose}>
                  <div className={classes.iconWrap} style={{ width: 28, height: 28 }}>
                    <SecurityIcon className={classes.btnIcon} />
                  </div>
                  <span className={classes.clientMenuLabel}><FormattedMessage id="policy" /></span>
                </Button>
              </a>
              <Button className={classes.clientMenuItem} onClick={() => { handleClientClose(); router.history.push('/carts'); }}>
                <div className={classes.iconWrap} style={{ width: 28, height: 28 }}>
                  <IconCart className={classes.btnIcon} />
                </div>
                <span className={classes.clientMenuLabel}>Panier</span>
                <div style={{ marginLeft: 'auto' }}>
                  <span style={{ fontSize: 12, color: '#888' }}>{apaveProducts.length}</span>
                </div>
              </Button>
            </div>
          </Popover>
        </div>
      </Toolbar>
    </AppBar >
  );
};

TopBar.propTypes = {
  openDrawer: PropTypes.bool,
  setOpenDrawer: PropTypes.func,
  location: PropTypes.any
};

export default TopBar;
